<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.dept"
                            :label="label.dept"
                            :error-messages="errors.collect('dept')"
                            data-vv-name="dept"
                            :data-vv-as="label.dept"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-autocomplete
                            :label="label.profType"
                            :items="profTypeList"
                            v-model="filter.profType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="profType"
                            :data-vv-as="label.profType"
                            :error-messages="errors.collect('profType')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.bandRefNo"
                            :label="label.bandRefNo"
                            :error-messages="errors.collect('bandRefNo')"
                            data-vv-name="bandRefNo"
                            :data-vv-as="label.bandRefNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.uppLim"
                            :label="label.uppLim"
                            :data-vv-as="label.uppLim"
                            data-vv-name="uppLim"
                            :error-messages="errors.collect('uppLim')"
                            v-validate="'numeric|max:13'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filter.bandDesc"
                            :label="label.bandDesc"
                            :error-messages="errors.collect('bandDesc')"
                            data-vv-name="bandDesc"
                            :data-vv-as="label.bandDesc"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Risk Profile
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.dept }}</td>
                  <td class="text-xs-left">{{ row.item.profType }}</td>
                  <td class="text-xs-left">{{ row.item.bandRefNo }}</td>
                  <td class="text-xs-left">{{ row.item.uppLim }}</td>
                  <td class="text-xs-left">{{ row.item.bandDesc }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      query
                      @query="doQuery(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Risk Profile?</p>
        <div class="queryValue">
          Profile Type: {{ selected.profType }}<br />
          Description: {{ selected.bandDesc }}
        </div>
      </confirm>
    </div>
    <!-- helplist -->
    <v-dialog v-model="showDeptList" width="1280px">
      <dept-help-list @close="showDeptList = false" @assign-dept="assignDept"></dept-help-list>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { profType } from '@/const/underwriting/riskProf'
import DeptHelpList from '@/components/core/common/dialog/DeptHelpList'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      headers: [
        { text: 'Dept', value: 'dept' },
        { text: 'Profile Type', value: 'profType' },
        { text: 'Band Ref', value: 'bandRefNo' },
        { text: 'Upper Limit', value: 'uppLim' },
        { text: 'Desc', value: 'bandDesc' },
        TableConst.tableActionHeader
      ],
      label: {
        dept: 'Department',
        deptDesc: 'Dept Desc',
        profType: 'Profile Type',
        bandRefNo: 'Band Ref No.',
        uppLim: 'Upper Limit',
        bandDesc: 'Band Ref Desc'
      },
      filter: {
        dept: null,
        profType: null,
        bandRefNo: null,
        uppLim: undefined,
        bandDesc: undefined
      },
      totalItems: 0,
      promptRemove: false,
      selected: {},
      showDeptList: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getRiskProfList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  dept: datamap.dept,
                  profType: datamap.profType,
                  bandRefNo: datamap.bandRefNo,
                  uppLim: datamap.uppLim,
                  bandDesc: datamap.bandDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      this.$router.push({ name: 'riskProfReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'riskProfReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doReview(obj) {
      this.$router.push({ name: 'riskProfReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.selected = data
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected) {
        const apiURI = this.menu.deleteRiskProf
        if (apiURI) {
          this.$http
            .post(apiURI, this.selected)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.dept = undefined
      this.filter.profType = undefined
      this.filter.bandRefNo = undefined
      this.filter.uppLim = undefined
      this.filter.bandDesc = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    getHelpList() {
      this.resetMessages()
      this.showDeptList = true
    },
    assignDept(dept) {
      this.filter.dept = dept
    }
  },
  computed: {
    menu() {
      return this.$store.state.riskProfParam.menu
    },
    profTypeList() {
      let result = []
      Object.keys(profType).forEach(function (key) {
        const status = profType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  components: {
    DeptHelpList
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
